export const SidebarMenuItem = {
  props: {
    item: Object,
    isYellow: Boolean
  },
  template: `
  <li>
    <a :href="'#' + item.id"
      :class="isYellow ? 'link-yellow' : ''">
      {{item.label}}
    </a>
  </li>
  `
}
